import React, { FC } from "react";
import { navigate, RouteComponentProps } from "@reach/router";
import LinearProgress from "@material-ui/core/LinearProgress";

import { useUser } from "UserContext";
import { auth } from "firebase-tools/firebase";
import NotFound from "components/NotFound";

const PrivateRoute: FC<RouteComponentProps> = ({ children }) => {
  const [user]: any = useUser();

  if (!Object.keys(user)?.length) {
    // Only bounce genuinely signed-out visitors. A signed-in user whose
    // user doc hasn't arrived yet (or whose Firestore read failed — Safari
    // wedges its connection while Auth stays healthy) must NOT be sent to
    // /sign-in: AuthHook immediately redirects signed-in users back off
    // /sign-in, and the two navigations ping-pong several times a second
    // (staff-reported screen flashing, 2026-08-14).
    if (auth.currentUser) {
      return <LinearProgress />;
    }
    navigate("/sign-in");
    return null;
  }

  if (window.location.pathname === "/admin-settings") {
    if (user?.role === "superAdmin") {
      return <div>{children}</div>;
    } else {
      return <NotFound />;
    }
  } else {
    if (user?.role && user?.role === "user") {
      return <NotFound />;
    } else {
      return <>{children}</>;
    }
  }
};

export default PrivateRoute;
